import { FilterItem, FilterType } from '@warema/shared/shop/shared/filters/models';

export const brochuresFilters: Array<FilterItem> = [
    {
        id: '1',
        name: 'SHOP.FILTER_PRODUCT_FENSTER_AND_FASSADE',
        iconPath: 'shared-assets/icons/shop/fenster_markisen.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Fenster & Fassade',
    },
    {
        id: '2',
        name: 'SHOP.FILTER_PRODUCT_TERRASSE_AND_GARTEN',
        iconPath: 'shared-assets/icons/shop/terrea_markise.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Terrasse, Garten & Wintergarten',
    },
    // {
    //     id: '3',
    //     name: 'SHOP.FILTER_PRODUCT_WINTERGARTEN',
    //     iconPath: 'assets/images/icons/shop/icon_wintergarten.svg',
    //     cssBackground: '',
    //     selected: false,
    //     filterType: FilterType.productFamilies,
    //     analyticsValue: 'Wintergarten',
    // },
    {
        id: '4',
        name: 'SHOP.FILTER_PRODUCT_SMART_HOME',
        iconPath: 'shared-assets/icons/phone.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Smart Home',
    },
    // {
    //     id: '05',
    //     name: 'SHOP.FILTER_PRODUCT_SONEA_AWNINGS',
    //     iconPath: 'assets/images/icons/shop/icon_sonea_sonnensegel.svg',
    //     cssBackground: '',
    //     selected: false,
    //     filterType: FilterType.productFamilies,
    // },
    // {
    //     id: '06',
    //     name: 'SHOP.FILTER_PRODUCT_LOUVRE_ROOF',
    //     iconPath: 'assets/images/icons/shop/icon_lamellendach.svg',
    //     cssBackground: '',
    //     selected: false,
    //     filterType: FilterType.productFamilies,
    // },
];
